/**
 *
 *	🚨🚨🚨 THIS FILE IS AUTOGENERATED 🚨🚨🚨
 *	TO MAKE CHANGES - PLEASE EDIT "./src/templates/components/Icon.tsx.ejs"
 *
 */

import React, { FC } from "react";
import cx from "clsx";
import { IconProps } from "../types";

const IconsList = [
	"announcement",
	"applications",
	"arriving",
	"arrow-down-micro",
	"arrow-down",
	"arrow-left-micro",
	"arrow-left",
	"arrow-right-micro",
	"arrow-right",
	"arrow-up-micro",
	"arrow-up",
	"attachment",
	"bag-tag",
	"baggage",
	"bar-graph",
	"biometric-scanning",
	"boarding-pass",
	"calendar-solid",
	"calendar",
	"captions",
	"car-rental",
	"change",
	"checkmark",
	"chevron-down-micro",
	"chevron-down",
	"chevron-left-micro",
	"chevron-left",
	"chevron-right-micro",
	"chevron-right",
	"chevron-up-micro",
	"chevron-up",
	"clock",
	"close-small",
	"close",
	"cloudy",
	"companion-solid",
	"companion",
	"component",
	"copy-micro",
	"credit-card",
	"deals-solid",
	"deals",
	"departing",
	"design",
	"digital-check-in",
	"dollar",
	"doublechevron-back-micro",
	"doublechevron-collapse-micro",
	"doublechevron-expand-micro",
	"doublechevron-forward-micro",
	"download-micro",
	"download",
	"edit",
	"email-solid-micro",
	"email",
	"end-end-micro",
	"end-start-micro",
	"entertainment",
	"exclamation",
	"expand",
	"external-micro",
	"fare-on-hold",
	"favourite-outline-micro",
	"favourite-outline",
	"favourite-partial-micro",
	"favourite-partial",
	"favourite-solid-micro",
	"favourite-solid",
	"fee-micro",
	"filter",
	"fireworks",
	"flight-micro",
	"flight-solid",
	"flight",
	"gate-closed",
	"gift-of-gold",
	"globe",
	"help-solid",
	"help",
	"higher-fee-micro",
	"home",
	"hotel",
	"impaired-mobility",
	"insurance",
	"lightning",
	"location",
	"lock-micro",
	"lock-unlock",
	"lock",
	"lounge",
	"menu",
	"microphone-mute",
	"microphone",
	"minus-micro",
	"minus",
	"more-solid",
	"more",
	"neutral-point-micro",
	"nope",
	"notifications",
	"onboard-menu",
	"overflow",
	"partly-cloudy",
	"pause-micro",
	"pets",
	"pie-chart",
	"pin-solid",
	"pin",
	"play-micro",
	"plus-micro",
	"plus",
	"pop-up",
	"popup-micro",
	"print",
	"profile-micro",
	"profile-solid",
	"profile",
	"qr-code",
	"question-micro",
	"question",
	"rainy",
	"rating-outline-micro",
	"rating-outline",
	"rating-partial-micro",
	"rating-partial",
	"rating-solid-micro",
	"rating-solid",
	"receipt",
	"refresh-micro",
	"refresh",
	"requirements",
	"rewards-chevron-solid",
	"rewards-chevron",
	"rewards-member",
	"search-micro",
	"search",
	"seat-upgrade",
	"seat",
	"send-micro",
	"send",
	"service-animal",
	"share",
	"shopping",
	"shrink",
	"snow",
	"speaker-muted",
	"speaker",
	"status-alert",
	"status-lift",
	"status-match",
	"stop-micro",
	"success",
	"sunny",
	"telephone",
	"text-size",
	"trash",
	"travel-documents",
	"trips-solid",
	"trips",
	"unavailable",
	"undo-micro",
	"undo",
	"upload-micro",
	"warning-micro",
	"warning",
	"weight",
	"westjet-dollars",
	"wi-fi-disconnect",
	"wi-fi-searching",
	"wi-fi",
	"windy",
] as const;

const Icon: FC<
	IconProps & {
		name: typeof IconsList[number];
	}
> = ({
	iconPrefix = "vwq-icon",
	name,
	className,
	title,
	hidden,
	fixedWidth,
	rotate,
	size,
	animate,
}) => (
	<span
		className={cx(iconPrefix, `${iconPrefix}-${name}`, className, {
			[`${iconPrefix}--${size}`]: size,
			[`${iconPrefix}--fw`]: fixedWidth,
			[`${iconPrefix}--r-${rotate}`]: rotate,
			[`${iconPrefix}--${animate}`]: animate,
		})}
		aria-label={title}
		aria-hidden={hidden}
	/>
);

Icon.displayName = "Icon";

export default Icon;
export { Icon };
